export const TicketData = [
  {
    id: 1,
    uuid: "052325125",
    subject: "Withdraw",
    submirredBy: "Luffy",
    status: "OPEN",
    priority: "MEDIUM",
    updated_at: "2025-11-22T14:17:26.000Z",
    created_at: "2025-11-19:04:13.000Z",
  },
  {
    id: 2,
    uuid: "66362514",
    subject: "Deposit",
    submirredBy: "SUNJI",
    status: "CUSTOMER REPLY",
    priority: "HIGH",
    updated_at: "2025-11-22T14:17:26.000Z",
    created_at: "2025-11-20:04:13.000Z",
  },
  {
    id: 3,
    uuid: "56321252",
    subject: "Role",
    submirredBy: "SOLO",
    status: "CUSTOMER REPLY",
    priority: "LOW",
    updated_at: "2025-11-22T14:17:26.000Z",
    created_at: "2025-11-22:04:13.000Z",
  },
];
